module.exports = __webpack_public_path__ + "static/media/IronMan.cd4362b8.jpg";